import React from "react";
import { getAllCustomers, CustomerResponse } from "../../services/customerService";

type AccountOption = { value: string; label: string };

export const useCustomerAccounts = (searchText: string) => {
    const [customers, setCustomers] = React.useState<CustomerResponse[]>([]);
    const [loading, setLoading] = React.useState(true);
    const [error, setError] = React.useState<string | null>(null);

    React.useEffect(() => {
        let mounted = true;
        const load = async () => {
            try {
                setLoading(true);
                const data = await getAllCustomers();
                if (!mounted) return;
                setCustomers(data);
            } catch (err: any) {
                if (!mounted) return;
                setError(err?.message || "Failed to load customers");
            } finally {
                if (!mounted) return;
                setLoading(false);
            }
        };

        load();
        return () => {
            mounted = false;
        };
    }, []);

    const filteredCustomers = React.useMemo(() => {
        const query = searchText.trim().toLowerCase();
        return customers
            .filter((c) => Boolean(c.cus_active))
            .filter((c) => `${c.cus_code ?? ""} ${c.cus_name ?? ""}`.toLowerCase().includes(query));
    }, [customers, searchText]);

    const accountOptions: AccountOption[] = React.useMemo(() => {
        return filteredCustomers.map((customer) => ({
            value: customer.cus_code ?? "",
            label: `${customer.cus_code ? `${customer.cus_code} - ` : ""}${customer.cus_name ?? "Unnamed customer"}`,
        }));
    }, [filteredCustomers]);

    return {
        loading,
        error,
        customers,
        filteredCustomers,
        accountOptions,
        panelTitle: "Customer Receipts",
        searchLabel: "Search customer",
        fieldPlaceholder: "Search active customer code or name",
        fieldListId: "customer-account-options",
        drawerTitle: "Search Customers",
        drawerPlaceholder: "Search by number, code or name",
    };
};
